import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { get as _get } from 'lodash';

import {
  hideNotification,
  showNotification,
} from 'actions';

import { locale } from 'utils/locale';

import localize from 'components/Localize/Localize';
import Notification from 'components/Notification/Notification';

import translations from './translations';

class CookieBanner extends React.Component {
  componentDidMount() {
    if (this.cookieEligible()) {
      this.props.showNotification(`cookieBanner`, `cookie`, this.props.t.message);
    }
  }

  getCookiesAccepted() {
    if (!window.localStorage || !window.sessionStorage) {
      return false;
    }

    return Boolean(JSON.parse(window.localStorage.getItem(`casperCookiesAccepted`)));
  }

  setCookiesAccepted() {
    if (!window.localStorage || !window.sessionStorage) {
      return false;
    }

    window.localStorage.setItem(`casperCookiesAccepted`, true);
  }

  cookieEligible() {
    if (locale(this.props.locale).isNA() || this.getCookiesAccepted()) {
      return false;
    }

    return true;
  }

  render() {
    if (!this.cookieEligible()) {
      return null;
    }

    return (
      <Notification
        keyName="cookieBanner"
        onClose={this.setCookiesAccepted.bind(this)}
      />
    );
  }
}

CookieBanner.propTypes = {
  locale: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  locale: _get(state, `i18n.locale`),
});

const mapDispatchToProps = (dispatch) => ({
  hideNotification: (key) => {
    dispatch(hideNotification(key));
  },

  showNotification: (key, type, message) => {
    dispatch(showNotification(key, { type, message }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(localize(CookieBanner, translations));
